import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatabaseEnumsCacheDto } from '../models/cache/database-enums-cache.model';
import Constants from '../Constants';
import { UserRoleIdUtil } from '../utils/UserRoleIdUtil';
import { UserPrivilegeEnum } from '../enums/rights/user-privilege.enum';
import { ChecklistTemplateType } from '../models/checklist-template/checlist-template-type.model';
import { DocumentGroupTypeModel } from '../models/document-group-type/document-group-type.model';
import { UserPermissionTopicEnum } from '../enums/rights/user-permission-topic.enum';
import { ClassUtils } from '../utils/ClassUtils';
import { FilterTemplateUtils } from '../utils/FilterTemplateUtils';
import { AbstractModuleTypeModel } from '../models/module/abstract-module-type.model';
import { OrganizationUtils } from '../utils/OrganizationUtils';
import { ServiceProvider } from '../models/service_provider/ServiceProvider';
import { ReportTypeUtils } from '../enums/report/report-type.enum';
import { AssessmentTypeUtils } from '../utils/AssessmentTypeUtils';
import { DocumentTypeModel } from '../models/document-type/document-type.model';
import { FilterUtil } from '../utils/filter/filter.util';

@Injectable({
  providedIn: 'root'
})
export class DatabaseEnumsCacheRequestService {

  //region INJECTIONS
  private httpClient = inject(HttpClient);
  //endregion

  loadDatabaseEnumsCache(): Observable<DatabaseEnumsCacheDto> {
    const url = Constants.URLS.cache.databaseEnums;
    return this.httpClient.get<DatabaseEnumsCacheDto>(url);
  }

  initializeValues(cacheData: DatabaseEnumsCacheDto) {
    UserRoleIdUtil.initialize(cacheData.userRightsRoleInternalCode);
    UserPrivilegeEnum.initialize(cacheData.userPrivileges);
    ChecklistTemplateType.initialize(cacheData.checklistTemplateTypeInternalCode);
    DocumentGroupTypeModel.initialize(cacheData.documentGroupTypeInternalCode);
    UserPermissionTopicEnum.initialize(cacheData.userPermissionTopicInternalCode);
    ClassUtils.initialize(cacheData.classInstanceValues);
    FilterTemplateUtils.initializeTemplateIds(cacheData.filterTemplateEntriesByPage);
    FilterTemplateUtils.initializeTemplateEntryIds(cacheData.filterTemplateEntriesByPage);
    AbstractModuleTypeModel.initialize(cacheData.moduleTypeInternalCode);
    OrganizationUtils.initialize(cacheData.orgInstanceValues);
    ServiceProvider.initialize(cacheData.spInstanceValues);
    ReportTypeUtils.initialize(cacheData.reportTypeValues);
    AssessmentTypeUtils.initialize(cacheData.assessmentTypeValues);
    DocumentTypeModel.initialize(cacheData.documentTypeValues);
    FilterUtil.initialize(cacheData.filterTemplateEntriesByPage);
  }
}
